// Types
import {
  DecodedLiveFrame,
  FrameImageFormat,
  FrameImageFormatValue,
} from "./types";

// 32-byte header written by exam-service in front of every relayed frame:
// 4-byte magic "RLLV", version, format, eye, flags, then capturedAt/relayedAt/
// sequence as little-endian int64s, followed by the raw JPEG/PNG bytes.
const HEADER_LENGTH = 32;
const PROTOCOL_VERSION = 1;
const MAGIC = [0x52, 0x4c, 0x4c, 0x56];

export const contentTypeOf = (format: FrameImageFormatValue): string =>
  format === FrameImageFormat.Png ? "image/png" : "image/jpeg";

export const decodeFrame = (buffer: ArrayBuffer): DecodedLiveFrame | null => {
  if (buffer.byteLength <= HEADER_LENGTH) return null;

  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < MAGIC.length; i++) {
    if (bytes[i] !== MAGIC[i]) return null;
  }
  if (bytes[4] !== PROTOCOL_VERSION) return null;

  const view = new DataView(buffer);
  const relayedAt = Number(view.getBigInt64(16, true));

  return {
    header: {
      format: bytes[5] as FrameImageFormatValue,
      eye: bytes[6],
      capturedAt: Number(view.getBigInt64(8, true)),
      relayedAt: relayedAt === 0 ? null : relayedAt,
      sequence: Number(view.getBigInt64(24, true)),
    },
    payload: buffer.slice(HEADER_LENGTH),
  };
};
